import React, { useState } from "react";
import Main from "../../components/Main";
import axios from "axios";
import styles from "./styles.module.css";
import {
  TextField,
  Button,
  Autocomplete,
} from "@mui/material";
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";


const ExportXml = () => {

  const [data, setData] = useState({ mes: '', ano: '', ultimoDiaMes: '' })
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");

  const options = [
    { id: '01', label: 'Janeiro' },
    { id: '02', label: 'Fevereiro' },
    { id: '03', label: 'Março' },
    { id: '04', label: 'Abril' },
    { id: '05', label: 'Maio' },
    { id: '06', label: 'Junho' },
    { id: '07', label: 'Julho' },
    { id: '08', label: 'Agosto' },
    { id: '09', label: 'Setembro' },
    { id: '10', label: 'Outubro' },
    { id: '11', label: 'Novembro' },
    { id: '12', label: 'Dezembro' }
  ]

  const handleChange = (event) => {
    const {
      name,
      value
    } = event.target

    setData({ ...data, [name]: value })
  }
  const handleAutoComplete = (value) => {
    value ? setData({ ...data, mes: value.id }) : setData({ ...data, mes: '' })


  }

  const gerarArquivosXML = (lista) => {
    if (lista.length !== 0) {
      const zip = new JSZip();
      lista.forEach((item, index) => {
        zip.file(`nota_${item.chave_nfe}.xml`, item.xml);
      });
      zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, `${data.ano}${data.mes}.zip`);
      });

      setMsg('Arquivo gerado com sucesso.')
      handleOpenSnackbarSucesso()
    }else{
      setMsg('Não possui dados para a data selecionada.')
        handleOpenSnackbarErro()
    }

  };

  const handleSubmit = async () => {
    await axios.post('http://localhost:4000/xml/retornar-xmls', data)
      .then((response) => gerarArquivosXML(response.data.xmls))
      .catch(err => {
        setMsg('Erro! Tente Novamente.')
        handleOpenSnackbarErro()
      })
  }

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };


  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };
  return (
    <>
      <Main />
      <div className={styles.container}>
        <div className={styles.item}>
          <div>
            <Autocomplete
              options={options}
              name="mes"
              value={options.find(item => item.id === data.mes)}
              onChange={(e, value) => handleAutoComplete(value)}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => <TextField {...params} label="Mês" />}
            />
            <TextField
              label="Ano"
              variant="outlined"
              placeholder="Ex: 2024"
              name="ano"
              value={data.ano}
              onChange={handleChange} />
            <TextField
              label="Último Dia do Mês"
              variant="outlined"
              placeholder="Ex: 28"
              name="ultimoDiaMes"
              value={data.ultimoDiaMes}
              onChange={handleChange} />
          </div>
          <Button
            sx={{ marginTop: '1rem' }}
            variant="contained"
            onClick={handleSubmit}
          >
            Gerar
          </Button>
        </div>
      </div>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </>
  );
};


export default ExportXml;
